import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const GradientDivider = styled(Box)(({ color, opacity = 0.6 }) => ({
  width: '85vw',
  height: '0.125rem',
  flexShrink: 0,
  background: `linear-gradient(to right, transparent 2%, ${color} 15%, ${color} 85%, transparent 98%)`,
  opacity,
}));

GradientDivider.propTypes = {
  color: PropTypes.string,
  opacity: PropTypes.number,
};

export default GradientDivider;
